module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-page', [_c('c-content', [_c('c-images', {
    attrs: {
      "img-items": _vm.images
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-text"
  }, [_c('div', {
    staticClass: "overlay-mask overlay-mask-one",
    on: {
      "click": _vm.openLaws
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-mask overlay-mask-two",
    on: {
      "click": _vm.goToProtocol
    }
  })])], 1), _vm._v(" "), _c('c-footer', {
    staticClass: "footer-shadow"
  }, [_c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.buy($event)
      }
    }
  }, [_c('div', [_vm._v("立即购买")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-178b09a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/senior/index.vue
// module id = 1022
// module chunks = 2